/* eslint-disable @typescript-eslint/no-explicit-any */
import type { V2DownlinePositionVM } from '~/composables/useRequest/requests/data-contracts';


export default async function getAllUpline(
  id: number,
  query: {
    /**
         * @min 1
         * @max 500
         * @example 10
         */
    limit?: number;
    /**
     * @min 0
     * @example 0
     */
    page?: number;
    /** @example 0 */
    treeId?: any;
    /** @example null */
    positionId?: any;
    /**
     * @min 1
     * @example 1
     */
    offset?: any;
    /**
     * target position to which the upline is requested
     * @min 1
     * @example 1
     */
    targetPositionId?: any;
    /**
     * Requested marketing properties
     * @example ["PV","AR"]
     */
    properties?: string;
  },
): Promise<V2DownlinePositionVM[]> {
  const { account } = useRequest();
  const data: {
    list: V2DownlinePositionVM[];
    total: number;
  } = { list: [], total: 0 };

  try {
    const { payload: { list, total } } = await account.uplineControllerGetUpline(id, {
      ...query,
      limit: 100,
      page: query.page || 0,
    });

    data.list = list;
    data.total = total;
  } catch {}

  if (((query.page || 0) + 1) * (query.limit || 100) < data.total) {
    try {
      const list = await getAllUpline(id, {
        ...query,
        page: (query.page || 0) + 1,
      });

      return data.list.concat(list);
    } catch {
      return [];
    }
  }

  return data.list;
}
